import { FormInputPasswordCustom } from '@extend/antd/form/FormInputPasswordCustom'
import { LockIcon } from '@shares/DMPIcon'
import { Icon } from 'antd'
import Form, { WrappedFormUtils } from 'antd/lib/form/Form'
import React from 'react'

type TFormInputPassword = {
    form: WrappedFormUtils
}

const FormInputPassword = (props: TFormInputPassword) => {
    return (
        <Form.Item label="Password" style={{ marginBottom: 0, paddingBottom: 0 }}>
            {props.form.getFieldDecorator('password', {
                rules: [{ required: true, message: "Please enter your email password" }]
                // props.locale.message["app.login.password.required"]
            })(
                <FormInputPasswordCustom

                    type="password"
                    autoComplete="off"
                    placeholder="Enter your password"
                    prefix={
                        <Icon
                            component={LockIcon}
                            style={{ paddingRight: 10 }}
                        />
                    }
                />
            )}
        </Form.Item>
    )
}

export default FormInputPassword